module.exports = __webpack_public_path__ + "static/media/logo.d851877a.png";